import { render, staticRenderFns } from "./ReenviarEmail.vue?vue&type=template&id=275574a4&scoped=true"
import script from "./ReenviarEmail.vue?vue&type=script&lang=js"
export * from "./ReenviarEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275574a4",
  null
  
)

export default component.exports